import {
  Box,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextareaAutosize,
  Typography,
} from "@mui/material";
import { FunctionComponent } from "react";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PageLoader from "../../app/PageLoader";
import { useGetQuotationByIdQuery } from "../../../redux/reducer/features/Quotation/quotationSlice";
import { useSelector } from "react-redux";
import { AppState } from "../../../redux/reducer/rootReducer";
import { formatDate } from "../../Order/OrderGrid";
interface QuotationDetailDialogProps {
  isOpen: boolean;
  onClose: any;
  quationId: any;
}

const QuotationDetailDialog: FunctionComponent<QuotationDetailDialogProps> = (
  props
) => {
  const { data, isLoading, isFetching } = useGetQuotationByIdQuery(
    { id: props.quationId },
    { skip: props.quationId === undefined || props.quationId === "" }
  );
  const { dmsSetup } = useSelector((state: AppState) => state.authReducer);
  return (
    <>
      <PageLoader isLoading={isLoading || isFetching} />
      {!(isLoading || isFetching) && (
        <Dialog
          open={props.isOpen}
          onClose={() => {
            props.onClose();
          }}
          maxWidth={"lg"}
          fullWidth
        >
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: 0,
              paddingLeft: "39px",
              paddingRight: "39px",
            }}
          >
            <h4>Leads</h4>
            <IconButton
              onClick={() => {
                props.onClose();
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ padding: 0 }}>
            <Container maxWidth="xl">
              <Grid container spacing={3} p={2} pt={0}>
                <Grid item xs={12} sm={2}>
                  <Typography className="bold">Customer Name</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  {data?.entity?.customerQuotation?.firstName +
                    " " +
                    data?.entity?.customerQuotation?.lastName}
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography className="bold">Email</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  {data?.entity?.customerQuotation?.email}
                </Grid>
              </Grid>
              <Grid container spacing={3} p={2} pt={0}>
                <Grid item xs={12} sm={2}>
                  <Typography className="bold">Phone</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  {data?.entity?.customerQuotation?.phone}
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography className="bold">Title</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  {data?.entity?.shopifyProduct !== null ? (
                    <>
                      {data?.entity?.shopifyProduct?.title}
                      <IconButton
                        aria-label="viewOrder"
                        disabled={data?.entity?.shopifyProduct ? false : true}
                        size="small"
                        onClick={() => {
                          window.open(
                            `${dmsSetup?.shopifyUrl}/products/${data?.entity?.shopifyProduct?.handle}`,
                            "_blank"
                          );
                        }}
                      >
                        <VisibilityIcon fontSize="small" />
                      </IconButton>
                    </>
                  ) : (
                    <Typography>
                      {data?.entity?.customerQuotation?.productTitle}
                    </Typography>
                  )}
                </Grid>
              </Grid>
              <Grid container spacing={3} p={2} pt={0}>
                <Grid item xs={12} sm={2}>
                  <Typography className="bold">Product Type</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  {data?.entity?.shopifyProduct?.productType}
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography className="bold">Vendor</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  {data?.entity?.shopifyProduct !== null
                    ? data?.entity?.shopifyProduct?.vendor
                    : data?.entity?.customerQuotation?.manufacturer}
                </Grid>
              </Grid>
              <Grid container spacing={3} p={2} pt={0}>
                <Grid item xs={12} sm={2}>
                  <Typography className="bold">Date</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  {formatDate(data?.entity?.customerQuotation?.createdAt)}
                </Grid>
              </Grid>
              <Grid container spacing={3} p={2} pt={0}>
                <Grid item sm={12}>
                  <Typography className="bold">Message</Typography>
                  <TextareaAutosize
                    aria-label="empty textarea"
                    placeholder="Message"
                    id={"description"}
                    name={"description"}
                    minRows={5}
                    style={{ width: "100%" }}
                    disabled
                    value={data?.entity?.customerQuotation?.message}
                  />
                </Grid>
              </Grid>
            </Container>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default QuotationDetailDialog;
